exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1gN8uXOfybjSaC{text-align:center;margin-bottom:12px}._9_-qCCbjiiNeHt{margin-bottom:0}._17ubmepy2-mYZb{flex:1 1 auto;overflow-y:auto;overflow-x:hidden;z-index:1;min-height:0}._13EPD62dgXxJoa{width:100%;margin-bottom:8px}", ""]);

// exports
exports.locals = {
	"emptyStateMessage": "_1gN8uXOfybjSaC",
	"createNewTemplateButton": "_9_-qCCbjiiNeHt",
	"templateCards": "_17ubmepy2-mYZb",
	"templateCard": "_13EPD62dgXxJoa"
};